import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css']
})
export class SidemenuComponent implements OnInit {

  slug: string = '';
  constructor(private router: Router)
  {

  }

  ngOnInit ()
  {
    // IF WE SUCCESSFULLY GOT THE URL?
    if (this.router.url)
    {
      let url = this.router.url; // STORING THE URL INTO LOCAL VARIABLE.
      let urlArray = url.split('/'); // SPLITTING THE URL ON THE BASIS OF SLASH.

      if(urlArray[ 1 ])
        this.slug = urlArray[ 1 ]; // GETTING THE VALUE AT INDEX 1.
      else
        this.slug = '';
    }
  }

}
